import VMenu from './VMenu'

export { VMenu }
export default VMenu
